import { jsx as _jsx } from "react/jsx-runtime";
import { BrandFilter, BrandFilterItem } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { BrandListerGroupedFilterTypes } from '@as-react/common-types';
import { Box, useIsClient } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
export const BrandListerFilters = ({ filters, onClick }) => {
    const { t } = useTranslation(I18N_NAMESPACES.brand);
    const { canonicalUrl } = useAemConfig();
    const isClient = useIsClient();
    const getFilterTitle = (key) => {
        if (key === BrandListerGroupedFilterTypes.ALL) {
            return t('brandlister.overview.navigation.all');
        }
        else if (key === BrandListerGroupedFilterTypes.POPULAR) {
            return t('brandlister.overview.navigation.popular');
        }
        return key;
    };
    const getHref = (key) => {
        const canonical = isClient ? window.location.href : canonicalUrl;
        const url = new URL(canonical);
        url.searchParams.set('filter', key);
        return url.toString();
    };
    return (_jsx(Box, { paddingBlockStart: "6", paddingBlockEnd: "1", children: _jsx(BrandFilter, { children: filters === null || filters === void 0 ? void 0 : filters.map((filter) => (_jsx(BrandFilterItem, { title: getFilterTitle(filter.key), filterKey: filter.key, active: filter.active, href: getHref(filter.key), onClick: onClick }, filter.key))) }) }));
};
